import { Serializable } from '@admin/core/models/serializable';
import { HrsExceptionCode } from '@admin/shared/models/hrs-exception-code.enum';

export class AnnouncementMatchingGenerationResultModel
  implements Serializable<AnnouncementMatchingGenerationResultModel>
{
  fromObject(obj: any): AnnouncementMatchingGenerationResultModel {
    Object.assign(this, obj);
    return this;
  }

  toObject() {
    throw new Error('Method not implemented.');
  }

  public success: boolean;
  public error: string;
  public errorCode: number;
  // public errorCode: HrsExceptionCodeEnum;
}
